const handleAnnoCheckbox = (excludeCheck: string = '') => {
    const tempInputs = document.getElementsByClassName('toggle_slide_anno') as HTMLCollectionOf<HTMLInputElement>
    Array.from(tempInputs).forEach(i => {
        if (i.id !== excludeCheck) i.checked = false 
    })
}

export {
    handleAnnoCheckbox
}